(() => {
  const clean = (value) => (value || '').replace(/\s+/g, ' ').trim();

  const enhance = (card) => {
    if (!card || card.dataset.sierraVariantPreview === 'true') return;

    const imageArea = card.querySelector('.product-featured-image');
    const primaryImage = imageArea?.querySelector('.product-primary-image');
    const swatches = [...card.querySelectorAll('.product-card-swatch[data-srcset]')]
      .filter((swatch) => clean(swatch.dataset.srcset));

    card.dataset.sierraVariantPreview = 'true';
    if (!imageArea || !primaryImage || swatches.length < 2) return;

    let originalSrcset = '';
    let originalActiveSwatch = null;

    imageArea.addEventListener('mouseenter', () => {
      originalSrcset = primaryImage.getAttribute('srcset') || primaryImage.dataset.srcset || '';
      originalActiveSwatch = card.querySelector('.product-card-swatch.active');

      const currentIndex = swatches.findIndex((swatch) => swatch.dataset.srcset === originalSrcset);
      const nextIndex = currentIndex >= 0 ? (currentIndex + 1) % swatches.length : 1;
      const previewSwatch = swatches[nextIndex];
      if (!previewSwatch || previewSwatch.dataset.srcset === originalSrcset) return;

      primaryImage.setAttribute('srcset', previewSwatch.dataset.srcset);
      swatches.forEach((swatch) => swatch.classList.remove('active'));
      previewSwatch.classList.add('active');
      card.classList.add('sierra-card--variant-preview');
    });

    imageArea.addEventListener('mouseleave', () => {
      if (!originalSrcset) return;
      primaryImage.setAttribute('srcset', originalSrcset);
      swatches.forEach((swatch) => swatch.classList.remove('active'));
      if (originalActiveSwatch) originalActiveSwatch.classList.add('active');
      card.classList.remove('sierra-card--variant-preview');
      originalSrcset = '';
      originalActiveSwatch = null;
    });
  };

  const enhanceAll = (root = document) => {
    root.querySelectorAll('.product-card.sierra-card-system').forEach(enhance);
  };

  window.SierraCardInteractions = { enhance, enhanceAll };
  document.addEventListener('shopify:section:load', (event) => enhanceAll(event.target));

  const dynamicCardObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches('.product-card.sierra-card-system')) enhance(node);
        enhanceAll(node);
      });
    });
  });

  document
    .querySelectorAll('product-recommendations, recently-viewed-products, #ProductGridContainer')
    .forEach((root) => dynamicCardObserver.observe(root, { childList: true, subtree: true }));

  enhanceAll();
})();
